// extracted by mini-css-extract-plugin
export default {"label":"label-RY7JM","container":"container-dmxuR","innerTooltip":"innerTooltip-yTd1B","spaceBtw":"spaceBtw-Tdfum"};